module.exports = __webpack_public_path__ + "img/sound_mute_fill.97e26ea2.svg";